import {httpGetJson} from './http';

export const loginStatus = {
  AUTHENTICATED: 'account_authenticated',
  UNAUTHENTICATED: 'not_recognised',
} as const;

export type LoginStatus = (typeof loginStatus)[keyof typeof loginStatus];

export type AccountInformationAuthenticated = {
  accountId: number;
  email: string;
  intlPhoneNumber: string;
  firstName: string;
  lastName: string;
  gender: string;
  loginStatus: typeof loginStatus.AUTHENTICATED;
};

export type AccountInformationUnauthenticated = {
  loginStatus: typeof loginStatus.UNAUTHENTICATED;
};

export type AccountInformationApiResponse =
  | AccountInformationUnauthenticated
  | AccountInformationAuthenticated;

export function fetchAccountInformation() {
  return httpGetJson<AccountInformationApiResponse>({
    path: '/api/v1/me/information',
  });
}
